import { gql } from '@apollo/client';

const QUERY_SINGLE_QUIZ = gql`
  query SingleQuiz($id: ID!) {
    findOneAvailableQuiz(id: $id) {
      name
      desc
      questions {
        data {
          id
          attributes {
            name
            reponse1
            reponse2
            reponse3
          }
        }
      }
    }
  }
`;
export default QUERY_SINGLE_QUIZ;
